module.exports = __webpack_public_path__ + "static/media/icon-ball.2116131b.svg";